import axios from "axios";
import { Message } from "element-ui";
import router from "../router/index";
export const BaseUrl = process.env.VUE_APP_API_BASE_URL;
export const BaseImgUrl = process.env.VUE_APP_API_BASE_URL + "/preview/";
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
// axios设置请求头
axios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem("token")) {
      config.headers["X-Access-Token"] = localStorage.getItem("token");
      // config.headers['X-Access-Token'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE2NDg2MDI5NTgsInVzZXJuYW1lIjoiMTU2MzU0NTE0NTEifQ.y4UPj-gnDFa-JJzzSs-MQJ6beD1xWx0zvepWdjjtsGE'
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//get
export function getAction(url, params) {
  return axios({
    url: url,
    method: "get",
    params: params,
  });
}
// post
export function postAction(url, data) {
  return axios({
    url: url,
    method: "post",
    data: data,
  });
}
// put
export function putAction(url, data) {
  return axios({
    url: url,
    method: "put",
    data: data,
  });
}
// delete
export function deleteAction(url, params) {
  return axios({
    url: url,
    method: "delete",
    params: params,
  });
}
// export
export function exportAction(url, data) {
  return axios({
    url: url,
    method: "post",
    responseType: "blob",
    data,
  });
}
// 首页
export function getHomeData(params) {
  return axios({
    url: "/home/info",
    method: "get",
    params,
  });
}
export function getBasicBannerList(params) {
  return axios({
    url: "/infrastructure/basicBanner/list",
    method: "get",
    params,
  });
}
//账号密码登录
export function accountLogin(data) {
  return axios({
    url: "/sys/login",
    method: "post",
    data,
  });
}
//账号登录
export function zhxyLogin(data) {
  return axios({
    url: "/sys/zhxyLogin",
    method: "post",
    data,
  });
}

//手机号登录
export function phoneLogin(data) {
  return axios({
    url: "/sys/phoneLogin",
    method: "post",
    data,
  });
}
//注册
export function register(data) {
  return axios({
    url: "/sys/user/register",
    method: "post",
    data,
  });
}
// 重复校验接口
export function repeatCheck(params) {
  return axios({
    url: "/sys/duplicate/check",
    method: "get",
    params,
  });
}
// 添加访问量
export function addViewNumber(params) {
  return axios({
    url: "/course/teachCourseConstruction/visual/addViewNumber",
    method: "get",
    params,
  });
}
// 获取用户信息
export function getUserInfo(params) {
  return axios({
    url: "/sys/info",
    method: "get",
    params,
  });
}

export function queryAllDictItems() {
  return axios({
    url: "/visual/sys/dict/queryAllDictItems",
    method: "get",
  });
}
// 查询资源引用媒体类型
export function getMediaType(params) {
  return axios({
    url: "/visual/sys/api/getMediaTypeList",
    method: "get",
    params,
  });
}
// 查询资源引用应用类型
export function getApplyType(params) {
  return axios({
    url: "/visual/sys/api/getResourceTypeList",
    method: "get",
    params,
  });
}

export function secretLogin() {
  return axios({
    url: "/sys/secretLogin",
    method: "post",
  });
}
//资源评价id查询
export function getInfo() {
  return axios({
    url: "/sys/info",
    method: "get",
  });
}
export function downloadRes(fileUrl) {
  return axios({
    url: `/sys/common/static${fileUrl}`,
    method: "get",
    responseType: "blob",
  });
}
export function getFileAccessHttpUrl(avatar, subStr) {
  if (!subStr) subStr = "http";
  try {
    if (avatar && avatar.startsWith(subStr)) {
      return avatar;
    } else {
      // window._CONFIG['staticDomainURL']
      if (avatar && avatar.length > 0 && avatar.indexOf("[") == -1) {
        return BaseUrl + "/preview/" + avatar;
      }
    }
  } catch (err) {
    return;
  }
}
//响应拦截
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.code === 500) {
      if (response.config.url != "/sys/duplicate/check") {
        Message.error({
          showClose: true,
          message: response.data.message,
          duration: 2000,
        });
      }

      // return Promise.reject(new Error('error'))
    }
    if (response.data.code === 510 && response.data.result != "505") {
      //console.log("response",response);
      Message.error({
        showClose: true,
        message: response.data.message,
        duration: 2000,
      });
    }
    return response;
  },
  (error) => {
    if (error.response) {
      //错误相应
      if (error.response.status === 401) {
        if (process.env.VUE_APP_SSO == "true") { //单点登录
          let sevice = "http://" + window.location.host + "/";
          let serviceUrl = encodeURIComponent(sevice);
          window.location.href = process.env.VUE_APP_CAS_BASE_URL;
          +"/authserver/login?service=" + serviceUrl;
        } else { // 正常登录
          const Token = window.localStorage.getItem("token");
          Message.error({
            showClose: true,
            message: "登录信息过期，请重新登录",
            duration: 2000,
          });
          window.localStorage.clear();
          setTimeout(() => {
            window.location.reload();
          }, 500);
          router.replace({
            name: "/",
            query: { redirect: router.currentRoute.fullPath }, //登录后再跳回此页面时要做的配置
          });
          localStorage.setItem("isOverdue", true);
        }
      } else {
        Message.error({
          showClose: true,
          message: "系统繁忙，请稍后再试",
          duration: 2000,
        });
        return Promise.reject(error);
      }
    }
  }
);
